/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable promise/catch-or-return */

import { useState } from 'react';

import permissionsSkynetApi from '../data/permissionsSkynetApi';
import { User } from '../types/User';

interface UseUsersState {
  users: User[];
  requestSent: boolean;
}

export const useUsersByScope = (scope: string) => {
  const [state, setState] = useState<UseUsersState>({
    users: [],
    requestSent: false,
  });
  const fetchUsers = () => {
    if (state.requestSent) {
      return;
    }
    setState((prevState) => ({
      ...prevState,
      requestSent: true,
    }));
    permissionsSkynetApi.fetchUsersByScope(scope).then((users) => {
      setState((prevState) => ({
        ...prevState,
        users,
      }));
    });
  };
  return { users: state.users, fetchUsers };
};
